import * as React from 'react';


import clsx from 'clsx';
import { useFormikContext } from 'formik';

import { useStepper } from '../context';
import { Icon } from '@eduzz/ui-antd-theme';

const steps = ['Dados bancários', 'Documentos', 'Comprovante', 'Resumo', 'Verificação'];

function Wizard() {
  const { currentStep, goToStep } = useStepper();
  const formik = useFormikContext();

  function handleDoneClick(stepPosition: number) {
    goToStep(stepPosition);
  }

  const hasStepsFinished = currentStep > steps.length;
  const offsetMultiplier = (hasStepsFinished ? steps.length : currentStep) - 1;
  const topByStep = ['top-0', 'top-8', 'top-16', 'top-24', 'top-32'] as const;
  const indicatorTopClass = topByStep[Math.min(offsetMultiplier, topByStep.length - 1)];

  return (
    <aside className='[&_nav>span]:bg-primary [&_ol]:border-outline-default absolute -left-1/2 h-full max-[1500px]:left-[-30%] max-[1100px]:hidden [&_nav]:fixed [&_nav]:-translate-x-1/2 [&_nav>span]:absolute [&_nav>span]:left-0 [&_nav>span]:h-8 [&_nav>span]:w-0.5 [&_nav>span]:transition-[top,opacity] [&_nav>span]:duration-500 [&_ol]:flex [&_ol]:list-none [&_ol]:flex-col [&_ol]:border-l'>
      <nav>
        <span
          className={`${indicatorTopClass} ${hasStepsFinished ? 'opacity-0' : ''}`}
          role='presentation'
          aria-valuenow={currentStep}
        />
        <ol>
          {steps.map((step, index) => {
            const position = index + 1;
            const isDone = currentStep > position;
            const isCurrent = currentStep === position;
            const isNext = currentStep < position;
            return (
              <li
                key={step}
                className={clsx(
                  isDone && '[&_button]:text-content-subtitle [&_button]:cursor-pointer',
                  isCurrent && '[&_button]:text-primary [&_button]:font-bold',
                  isNext && '[&_button]:text-content-caption [&_button]:cursor-not-allowed'
                )}
                {...(isDone && { onClick: () => handleDoneClick(position) })}
              >
                <button
                  className='flex h-8 items-center border-0 bg-transparent pl-4 font-sans text-sm leading-8 font-semibold disabled:cursor-not-allowed'
                  id={`step-nav-btn-${position}`}
                  disabled={formik?.isSubmitting}
                >
                  <Icon.CircleCheck
                    className={clsx(
                      'mr-1.25 w-0 scale-0 text-base text-(--uizz-antd-color-success) transition-[transform,width] duration-500',
                      isDone && 'w-4 scale-100'
                    )}
                   />
                  {step}
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
    </aside>
  );
}

export { Wizard };
